// loader.service.ts
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LoaderService {
  private activeRequests = 0;
  isLoading = new Subject<boolean>();

  showLoader() {
    this.activeRequests++;
    // Emit 'true' if there is at least one active request.
    this.isLoading.next(true);
  }

  hideLoader() {
    // Decrement, but never go below 0 to avoid negative counts
    this.activeRequests = Math.max(0, this.activeRequests - 1);
    // Emit 'false' if there are no more active requests.
    if (this.activeRequests === 0) {
      this.isLoading.next(false);
    }
  }
}
